import React from "react"
import "./uploadButton.less"
import Row from "antd/es/row";
import Col from "antd/es/col";
import CloseSquareOutlined from "@ant-design/icons/CloseSquareOutlined";
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import {clone, reject} from 'lodash';
import notification from "antd/es/notification";
import {useTranslation} from "react-i18next";

const UploadedFiles = (props) => {

    var renderElement;
    if (props.multiple === false) {
        renderElement = props.files !== null ?
            <div className={'filesList'}>
                <Row className={'fileItem'}>
                    <Col>{props.files.name}</Col>
                    <Col className={'closeBtn'}><a onClick={() => {
                        props.setFiles(null);
                    }}><CloseSquareOutlined/></a></Col>
                </Row>
            </div> : <></>
    } else {
        renderElement = props.files && props.files.length ? <div className={'filesList'}>
            {props.files.map((vv, kk) => {
                return (
                    <Row className={'fileItem'} key={kk}>
                        <Col>{vv.name}</Col>
                        <Col className={'closeBtn'}><a onClick={() => {
                            let temp = clone(props.files)
                            temp = reject(temp, (kj) => {
                                return kj == vv;
                            });
                            props.setFiles(temp);

                        }}><CloseSquareOutlined/></a></Col>
                    </Row>)
            })}
        </div> : null
    }
    return renderElement;
}


const Uploadbutton = (props) => {

    const {t} = useTranslation();

    const onClickHandler = (event) => {
        event.preventDefault();
        document.getElementById(props.id).click()
    }
    const onChangeHandler = (event) => {

        var validFileType = false;
        if(event.target.files[0].type.indexOf("image/") > -1){
            validFileType = true;
        }
        if(event.target.files[0].type.indexOf("application/pdf") > -1){
            validFileType = true;
        }
        if(!validFileType){
            notification.error({
                message: `${t("notifications.invalid")} ${t("notifications.fileType")}`,
                description: t("notifications.fileTypeMessage"),
            });
            return;
        }else{
            if (props.multiple)
                props.onChange(event.target.files);
            else
                props.onChange(event.target.files[0]);
        }
        document.getElementById(props.id).value = "";
    }

    return (
        <div className={"uploadbtnCtr"}>
            <label htmlFor={props.id} style={{ marginBottom: '15px'}}>{props.label}</label>
            <button onClick={onClickHandler} disabled={props.disabled}>
                <UploadOutlined/>
                {props.text}
            </button>

            <input
                className={"input"}
                type={"file"}
                id={props.id}
                name={props.name}
                multiple={props.multiple}
                onChange={onChangeHandler}
            />
            <UploadedFiles
                multiple={props.multiple}
                files={props.files}
                setFiles={props.setFiles}
            />
            {/*{props.files && props.files.length ? <div className={'filesList'}>*/}
            {/*    {props.files.map((vv, kk) => {*/}
            {/*        return (<Row className={'fileItem'} key={kk}>*/}
            {/*            <Col>{vv.name}</Col>*/}
            {/*            <Col className={'closeBtn'}><a onClick={() => {*/}
            {/*                let temp = clone(props.files)*/}
            {/*                temp = reject(temp, (kj) => {*/}
            {/*                    return kj == vv;*/}
            {/*                });*/}
            {/*                props.setFiles(temp);*/}

            {/*            }}><CloseSquareOutlined/></a></Col>*/}
            {/*        </Row>)*/}
            {/*    })}*/}
            {/*</div> : null}*/}
        </div>
    );
}

export default Uploadbutton;